// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__Igl3b","buttons":"RemoveExpirationActionButtons_buttons__LD3PP"};